import * as React from 'react';
import MyPortfolioComponent from 'src/modules/my-portfolio/MyPortfolio.component';
import { RootState } from 'src/reducers/RootReducer';
import { connect, Dispatch } from 'react-redux';
import PhysicalPerson from 'src/entities/PhysicalPerson';
import User from 'src/entities/User';
import { getUser, GetUserAction } from 'src/actions/user/get/GetUser.actions';
import { getPhysicalPerson, GetPhysicalPersonAction } from 'src/actions/physical-person/get/GetPhysicalPerson.actions';
import {
  getIndexJuridicalPersons,
  GetIndexJuridicalPersonsAction
} from 'src/actions/juridical-person/index/GetIndexJuridicalPersons.actions';
import Project from 'src/entities/Project';
import {
  indexPersonInterestedProjects,
  IndexPersonInterestedProjectsAction
} from 'src/actions/project/index-person-interested/IndexPersonInterestedProjects.actions';
import {
  indexPersonInvestedProjects,
  IndexPersonInvestedProjectsAction
} from 'src/actions/project/index-person-invested/IndexPersonInvestedProjects.actions';
import Person from 'src/entities/Person';
import JuridicalPerson from 'src/entities/JuridicalPerson';
import { setActiveProfile } from 'src/actions/active-profile/set/SetActiveProfile.actions';
import { getProfileMetrics } from 'src/actions/profile-metrics/get/GetProfileMetrics.actions';
import ProfileMetrics from 'src/value-objects/ProfileMetrics';
import LoadingContainer from 'src/modules/commons/loading/Loading.container';
import {
  indexInvestments,
  IndexInvestmentsAction,
} from 'src/actions/investment/index/IndexInvestments.actions';
import InvestorType from 'src/entities/InvestorType';

interface StateProps {
  user?: User;
  physicalPerson?: PhysicalPerson;
  indexJuridicalPersons?: JuridicalPerson[];
  loggedUserData: number | null;
  invested: Project[];
  interested: Project[];
  activeProfile?: Person;
  metrics?: ProfileMetrics;
  investorType?: InvestorType;
}

interface DispatchProps {
  getUser(userId: number): Promise<GetUserAction>;

  getPhysicalPerson(physicalPersonId: number): Promise<GetPhysicalPersonAction>;

  getIndexJuridicalPersons(userId: number): Promise<GetIndexJuridicalPersonsAction>;

  indexPersonInterestedProjects(personId: number, personType: string): Promise<IndexPersonInterestedProjectsAction>;

  indexPersonInvestedProjects(personId: number, personType: string): Promise<IndexPersonInvestedProjectsAction>;

  setActiveProfile(person: Person): void;

  getProfileMetrics(profile: Person): void;

  indexInvestments(profileId: number, profileType: string, lastYear: boolean): Promise<IndexInvestmentsAction>;
}

interface State {
  project?: Project;
}

interface Props extends StateProps, DispatchProps {
}

class MyPortfolioContainer extends React.Component<Props, State> {

  public componentWillMount(): void {
    if (!this.props.user) {
      const userId = this.props.loggedUserData!;
      this.props.getUser(userId);
    } else {
      this.getUserRelatedData(this.props);
    }
  }

  public componentWillReceiveProps(newProps: Props): void {
    if (newProps.activeProfile && newProps.activeProfile !== this.props.activeProfile) {
      this.getUserRelatedData(newProps);
    }
  }

  public render(): React.ReactNode {
    return (
      this.props.physicalPerson && this.props.indexJuridicalPersons ?
        (
          <MyPortfolioComponent
            physicalPerson={this.props.physicalPerson}
            juridicalPersons={this.props.indexJuridicalPersons}
            interestedProjects={this.props.interested}
            investedProjects={this.props.invested}
            defaultProfile={this.props.user!.defaultProfile}
            handleClick={(index?: number) => this.handleProfileClick(index)}
            activeProfile={this.props.activeProfile}
            metrics={this.props.metrics}
          />
        ) :
        <LoadingContainer/>
    );
  }

  private handleProfileClick(index?: number): void {
    if (index && index !== this.props.physicalPerson!.id) {

      const juridicalPerson = this.props.indexJuridicalPersons!.find(obj => {
        return obj.id === index;
      });
      this.props.setActiveProfile(juridicalPerson!);
    } else {
      this.props.setActiveProfile(this.props.physicalPerson!);
    }
  }

  private getUserRelatedData(props: Props) {
    props.getPhysicalPerson(props.user!.physicalPersonId);
    props.getIndexJuridicalPersons(props.loggedUserData!);
    props.indexPersonInterestedProjects(props.activeProfile!.id, props.activeProfile!.personType);
    props.indexPersonInvestedProjects(props.activeProfile!.id, props.activeProfile!.personType);
    props.getProfileMetrics(props.activeProfile!);
  }
}

const mapDispatchToProps: (dispatch: Dispatch<RootState>) => DispatchProps = (
  dispatch: Dispatch<RootState>
): DispatchProps => {

  return {
    getUser: (userId: number): Promise<GetUserAction> => (
      dispatch(getUser(userId))
    ),
    getPhysicalPerson: (physicalPersonId: number): Promise<GetPhysicalPersonAction> => (
      dispatch(getPhysicalPerson(physicalPersonId))
    ),
    getIndexJuridicalPersons: (userId): Promise<GetIndexJuridicalPersonsAction> => (
      dispatch(getIndexJuridicalPersons(userId))
    ),
    indexPersonInterestedProjects: (
      personId: number,
      personType: string
    ): Promise<IndexPersonInterestedProjectsAction> => (
      dispatch(indexPersonInterestedProjects(personId, personType))
    ),
    indexPersonInvestedProjects: (personId: number, personType: string): Promise<IndexPersonInvestedProjectsAction> => (
      dispatch(indexPersonInvestedProjects(personId, personType))
    ),
    setActiveProfile: (person: Person) => (dispatch(setActiveProfile(person))),
    getProfileMetrics: (profile: Person) => (dispatch(getProfileMetrics(profile))),
    indexInvestments: (
      profileId: number, profileType: string, lastYear: boolean
    ): Promise<IndexInvestmentsAction> => (
      dispatch(indexInvestments(profileId, profileType, lastYear))
    )
  };
};

const mapStateToProps: (state: RootState) => StateProps = (state: RootState): StateProps => ({
  user: state.getUser.user,
  physicalPerson: state.getPhysicalPerson.physicalPerson,
  indexJuridicalPersons: state.getIndexJuridicalPersons.juridicalPersons,
  loggedUserData: state.authentication.loggedUserData,
  interested: state.indexPersonInterestedProjects.projects,
  invested: state.indexPersonInvestedProjects.projects,
  activeProfile: state.getUser.activeProfile,
  metrics: state.getUser.profileMetrics,
});

export default connect(mapStateToProps, mapDispatchToProps)(MyPortfolioContainer);



// WEBPACK FOOTER //
// ./src/modules/my-portfolio/MyPortfolio.container.tsx